<template>
  <div>
    <v-row
      align="center"
      class="white--text"
      :class="route.isFeasibleRoute ? 'green' : 'red'"
    >
      <v-col cols="4">
        <div class="d-flex justify-center text-left">
          <v-icon
            left
            dark
            large
          >
            mdi-map-marker-path
          </v-icon>
          <div>
            <div class="caption">
              Route
            </div>
            <div class="text-h5">
              {{ route.name }}
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="4">
        <div class="d-flex justify-center text-left">
          <v-icon
            left
            dark
            large
          >
            mdi-clock-outline
          </v-icon>
          <div>
            <div class="caption">
              Time
            </div>
            <div class="text-h5">
              {{ getTotalHours }}
            </div>
          </div>
        </div>
      </v-col>

      <v-col cols="4">
        <div class="d-flex justify-center text-left">
          <v-icon
            left
            dark
            large
          >
            mdi-texture-box
          </v-icon>
          <div>
            <div class="caption">
              Pallets
            </div>
            <div class="text-h5">
              {{ route.total_delivered_pallets }}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        style="min-height:400px;z-index: 0"
        class="lime lighten-5 pa-0"
        cols="12"
        md="5"
      >
        <bing-map
          :id="`map-${route.id}`"
          :center="{lat: locations[0].lat, lng: locations[0].lng}"
          :paths="route.path"
          :locations="locations"
        />
      </v-col>

      <v-col
        md="7"
        cols="12"
        class="py-0 pl-0"
        style="max-height:400px;overflow:auto"
      >
        <v-timeline dense>
          <v-timeline-item
            v-for="(path, index) in route.path"
            :key="index"
            small
            :color="route.isFeasibleRoute ? 'green' : 'red'"
            class="pb-3"
          >
            <v-card
              class="indigo lighten-5"
              shaped
              outlined
            >
              <v-card-title class="subtitle-2 pb-1 pt-2">
                <v-list
                  dense
                  class="transparent py-0"
                >
                  <v-list-item class="px-0">
                    <!-- TODO: use :color="!!path.logo" when it is available" -->
                    <v-list-item-avatar
                      size="25"
                      class="body-2 white--text mr-3"
                      :color="
                        index === 0 || (index === route.path.length - 1) ? 'primary' : '#737373'"
                    >
                      <!-- TODO: use v-if="path.logo" when it is available" -->
                      <img
                        v-if="false"
                        :src="getFullUrl(path.logo)"
                        :alt="path.address.street"
                      >
                      <span
                        v-else
                      >
                        {{ index + 1 }}
                      </span>
                    </v-list-item-avatar>

                    <v-list-item-content class="py-0 primary--text">
                      <v-list-item-title class="white-space-normal">
                        <span>{{ path.address.postcode }} - {{ path.address.street }}</span>
                      </v-list-item-title>
                    </v-list-item-content>

                    <v-list-item-action v-if="path.partial">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-icon
                            class="mb-1"
                            small
                            color="info"
                            v-on="on"
                          >
                            mdi-information
                          </v-icon>
                        </template>
                        <span>Partial Order</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card-title>

              <v-card-text class="pb-3">
                <div class="d-flex justify-space-between">
                  <div>
                    <div class="grey--text caption">
                      Arrival
                    </div>
                    <strong class="body-2">
                      {{ convertSecondToFormattedTime(path.arrival_time) }}
                    </strong>
                  </div>

                  <div>
                    <div class="grey--text caption">
                      Departure
                    </div>
                    <strong class="body-2">
                      {{ convertSecondToFormattedTime(path.dep_time) }}
                    </strong>
                  </div>

                  <div>
                    <div class="grey--text caption">
                      Pallets
                    </div>
                    <strong
                      :class="`${route.isFeasibleRoute ? 'green' : 'red'}--text`"
                      class="body-2"
                    >{{ path.number_pallets_dropped }}</strong>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { getFullUrl } from '@/utils/misc';
import BingMap from '@/components/commons/BingMap.vue';

export default {
  components: { BingMap },
  props: {
    route: {
      type: Object,
      required: true,
    },
    locations: {
      type: Array,
      required: true,
    },
  },
  computed: {
    getTotalHours() {
      const seconds = this.route.path[this.route.path.length - 1].total_travel_time;

      return this.convertSecondToFormattedDuration(seconds);
    },
  },
  methods: {
    getFullUrl,
    convertSecondToFormattedDuration(secs) {
      if (!secs) {
        return 'N/A';
      }

      const secNum = parseInt(secs, 10);
      const hours = Math.floor(secNum / 3600);
      const minutes = Math.floor(secNum / 60) % 60;

      return `${hours}h ${minutes}m`;
    },
    convertSecondToFormattedTime(secs) {
      if (!secs) {
        return 'N/A';
      }

      const padNumber = (number) => String(number).padStart(2, '0');

      const secNum = parseInt(secs, 10);
      const hours = padNumber(Math.floor(secNum / 3600));
      const minutes = padNumber(Math.floor(secNum / 60) % 60);

      return `${hours}:${minutes}`;
    },
  },
};
</script>

<style scoped>
.white-space-normal {
  white-space: normal;
}
</style>
